module.exports = __webpack_public_path__ + "static/logo-2d83f48679f132ae3a2ac4fdca391d15.svg";